<template>
  <div>
    <b-table
      responsive
      :busy="loading"
      ref="table"
      :fields="tableDataFields"
      :items="tableData"
      head-variant="light"
      hover
      class="bg-white"
      show-empty
      sort-icon-left
    >
      <template v-slot:cell(resTagType)="data">
        <b-badge
          :variant="data.item.resTagType === 'C'?'success':'warning'"
        >{{data.item.resTagType === 'C'?'公共标签':'私有标签'}}</b-badge>
      </template>
      <template v-slot:cell(resTagStatus)="data">
        <b-badge
          :variant="data.item.resTagStatus === 'Y'?'success':'danger'"
        >{{data.item.resTagStatus === 'Y'?'有效':'无效'}}</b-badge>
      </template>
      <template v-slot:cell(modifyInfo)="data">
        <div>
          <span>修改人: {{data.item.modifyByName}}</span>
          <br />
          <span>修改日期: {{data.item.modifyDate}}</span>
        </div>
      </template>
      <template v-slot:cell(operation)="data">
        <b-button-group>
          <b-button
            class="mr-2"
            v-b-tooltip.hover
            :title="$l('tips_view')||'查看'"
            @click="fromLoad('detail', data.item.resTagCode)"
            variant="outline-secondary"
            size="sm"
          >
            <b-icon-eye></b-icon-eye>
          </b-button>
          <b-button
            class="mr-2"
            v-b-tooltip.hover
            :title="$l('tips_edit')||'编辑'"
            @click="fromLoad('edit', data.item.resTagCode)"
            variant="outline-secondary"
            size="sm"
            v-if="allow('M')"
          >
            <b-icon-pencil></b-icon-pencil>
          </b-button>
          <b-button
            v-b-tooltip.hover
            :title="$l('tips_del')||'删除'"
            :disabled="data.item.resTagStatus === 'N'"
            @click="del([data.item.resTagCode])"
            variant="outline-secondary"
            size="sm"
            v-if="allow('D')"
          >
            <b-icon-trash-fill></b-icon-trash-fill>
          </b-button>
        </b-button-group>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center;">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{$l('INDEX.tips_no_data')||'暂无数据！'}}</p>
        </div>
      </template>
    </b-table>
    <!--编辑弹框-->
    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="800px"
    >
      <page-detail ref="form" @success="saveSuccess"></page-detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">{{$l('form_button_cancel')||'取 消'}}</el-button>
        <el-button
          type="primary"
          @click="save"
          size="small"
          v-show="formOption.dialogSaveBtnVisible"
        >{{$l('form_button_save')||'保 存'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  components: {
    PageDetail: () => import("./components/detail"),
  },
  data() {
    return {
      allChecked: false,
      indeterminate: false,
      selected: [],
      // 表单设置
      formOption: {
        title: "",
        dialogFormVisible: false,
        dialogSaveBtnVisible: true,
      },
      tableDataFields: [
        {
          key: "resTagName",
          label: this.$l("table_label_attribute_type") || "属性类型",
          tdClass: "align-middle",
        },
        {
          key: "resTagType",
          label: this.$l("table_label_tag_type") || "标签类型",
          tdClass: "align-middle",
        },
        {
          key: "resTagOwnerName",
          label: this.$l("table_label_tag_owner") || "标签所属人",
          tdClass: "align-middle",
        },
        {
          key: "resTagStatus",
          label: this.$l("table_label_status") || "有效状态",
          tdClass: "align-middle",
        },
        {
          key: "modifyInfo",
          label: this.$l("table_label_modifyInfo") || "修改信息",
          tdClass: "align-middle",
        },
        {
          key: "operation",
          label: this.$l("table_label_operation") || "操作",
          tdClass: "align-middle",
        },
      ],
    };
  },
  methods: {
    // 加载表单
    fromLoad(ref, val = "") {
      const opt = {
        add: "新增",
        edit: "编辑",
        detail: "详情",
      };
      let key;
      if (ref === "add") {
        key = "tips_add";
      } else if (ref === "edit") {
        key = "tips_edit";
      } else if (ref === "detail") {
        key = "tips_view";
      }
      // 设置标题
      this.formOption.title = this.$l(key) || opt[ref];
      // 控制保存按钮显隐
      if (ref === "detail") {
        this.formOption.dialogSaveBtnVisible = false;
      } else {
        this.formOption.dialogSaveBtnVisible = true;
      }
      // 显示表单
      this.formOption.dialogFormVisible = true;
      setTimeout(() => {
        // 调用组件表单加载方法
        this.$refs.form.fromLoad(ref, val);
      }, 0);
    },
    delRows() {
      let selection = this.selected;
      if (!selection || selection.length < 1) {
        this.$message({
          showClose: true,
          message:
            this.$l("INDEX.tips_question_del_rows") || "请选择需要删除的数据",
          type: "warning",
        });
        return;
      }
      let tempArray = [];
      selection.forEach((item) => {
        tempArray.push(item.resTagCode);
      });
      this.del(tempArray);
    },
    del(resTagCodeList) {
      this.$confirm(
        this.$l("INDEX.tips_question_delete") || "是否删除？",
        this.$l("INDEX.tips_question_title") || "提示",
        {
          confirmButtonText: this.$l("INDEX.tips_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
          type: "warning",
        }
      ).then(() => {
        this.$api.delResearchTagApi({ resTagCodeList }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l("INDEX.tips_delete_ok") || "删除成功！",
            type: "success",
          });
          this.$emit("submit");
        });
      });
    },
    save() {
      this.$refs.form.save();
    },
    saveSuccess() {
      this.cancel();
      this.$emit("submit");
    },
    cancel() {
      this.formOption.dialogFormVisible = false;
    },
    onRowSelected(items) {
      this.selected = items;
      if (items.length === 0) {
        this.indeterminate = false;
        this.allChecked = false;
      } else if (items.length === this.tableData.length) {
        this.indeterminate = false;
        this.allChecked = true;
      } else {
        this.indeterminate = true;
        this.allChecked = false;
      }
    },
    // 选中单行
    selectRow(index) {
      let isRowSelected = this.$refs.table.isRowSelected(index);
      if (isRowSelected) {
        this.$refs.table.unselectRow(index);
      } else {
        this.$refs.table.selectRow(index);
      }
    },
    // 表格全选/取消全选
    selectAllRows() {
      if (!this.allChecked) {
        this.$refs.table.selectAllRows();
      } else {
        this.$refs.table.clearSelected();
      }
    },
  },
};
</script>
